/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Toast_Create_OkInputs */

const vi_cdo_toast_create_ok = /** @type {(inputs: Cdo_Toast_Create_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo đơn giao hợp đồng`)
};

/**

* @param {Cdo_Toast_Create_OkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_toast_create_ok = /** @type {((inputs?: Cdo_Toast_Create_OkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Toast_Create_OkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_toast_create_ok(inputs)
});